export default {"src":"/_next/static/media/paaldansen.dd928ffa.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};